<template>
  <sc-btn v-if="type && value" :handler="open" :text="label || ''" type="link"/>
  <div v-else>{{ label }}</div>
</template>

<script lang="ts" setup>
import {computed, defineProps} from "vue";
import {windows} from "@/components/common/window/Windows";
import _ from "lodash";
import {MorphFieldType} from "@/components/business/crud/interface/FieldType";
import ScBtn from "@/components/common/widget/ScBtn.vue";
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";

const props = defineProps<{
  propName: string;
  widget: MorphFieldType;
  info: WidgetInfo;
  data: any;
}>();

const label = computed(() => {
  return _.get(props.data, [
    props.propName,
    "name",
  ]);
})

const value = computed(() => {
  return _.get(props.data, [
    props.propName,
    "id",
  ]);
})

const type = computed(() => {
  return _.get(props.data, props.widget.modelNameProp);
})

function open() {
  if (value.value && type.value) {
    windows.open({
      content: {
        type: 'route',
        href: props.widget.models[type.value].basePath + "/view?id=" + value.value
      },
      title: props.info.title + '详情',
    });
  }
}

</script>


<style lang="scss" scoped></style>
